import type { FormPlugin } from "./types";
const plugins: Record<string, any> = {};

export function getPlugin(name: string): FormPlugin | undefined {
  return plugins[name];
}

export function addPlugin(name: string, plugin: FormPlugin) {
  plugins[name] = plugin;
}

export * from "./types";